import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { UpdateProviderProfileBody } from "@shared-kernel/application/ports/provider/provider-repository";

export const updateProviderProfile = createAsyncThunk<void, UpdateProviderProfileBody, { extra: Partial<Dependencies> }>(
  "providers/updateProviderProfile",
  async (body: UpdateProviderProfileBody, { extra: { providerRepository } }) => {
    return providerRepository!.updateProfile(body);
  },
);

export const resetUpdateProviderProfile = createAction("providers/resetUpdateProviderProfile");
